import { Customer } from "@core/models/customer.model";
import { OrderCreationCustomerRole } from "@shared/enums/order-creation-customer-role";
import { NavigationState } from "@shared/models/navigation-state";

export class ChooseAdvertiserNavigationState extends NavigationState {
	override readonly className = "ChooseAdvertiserNavigationState";

	titleKey: string | undefined;
	customers: Customer[] | undefined;
	role?: OrderCreationCustomerRole;
}
